@if(vm$ | async; as vm){
    <div class="search-area">
        <div class="fieldset">
            <legend>Available Merge Fields</legend>

            <div class="field">
                <div class="value">
                    <search-box (search)="onSearch($event.search)" placeholder="<Search>"></search-box>
                </div>
            </div>

            <div class="field">
                <div class="value wrap-tags">
                    <div class="tag tag-none" [ngClass]="{active: item.active}" *ngFor="let item of vm?.entities" (click)="toggleEntity(item)">
                        {{item?.data}}
                    </div>
                </div>
            </div>

        </div>
    </div>


    <div class="list-area">
        @for (group of  vm?.filtered; track $index) {

            <div class="list-item list-item-group" (click)="group.expanded = !group.expanded">
                <div class="chevron margin-right-5">
                    <i class="fa" [ngClass]="{ 'fa-chevron-right': !group.expanded, 'fa-chevron-down': group.expanded }"></i>
                </div>
                <div class="content">
                    <div class="title">
                        {{group?.displayName}} ({{getCount(group)}})
                    </div>
                </div>
            </div>

            @if(group.expanded){

                @for (item of group.fields; track $index) {
                    @if(!item.hidden){
                        <div class="list-item list-item-field">
                            <div class="content">
                                <ng-container [ngTemplateOutlet]="hierarchicalFieldTemplate" [ngTemplateOutletContext]="{ item: item, level: 0, isPage: true, isFirst: $first }">
                                </ng-container>

                                @if(!!item.arrayFields?.length){
                                    <ul class="array-fields">
                                        <ng-container *ngFor="let subArrayItem of item.arrayFields" [ngTemplateOutlet]="arrayFieldTemplate" [ngTemplateOutletContext]="{ item: subArrayItem, level: 1 }">
                                        </ng-container>
                                    </ul>
                                }
                            </div>
                        </div>
                    }
                }
            }

            }
    </div>
    }

    <!-- Hierarchical structure for document theme available fields -->
    <ng-template #hierarchicalFieldTemplate let-item="item" let-level="level" let-isPage="isPage" let-isSection="isSection" let-isFirst="isFirst">
        @if(item?.fields?.length){
            <ng-container [ngTemplateOutlet]="hierarchyHeaderTemplate" [ngTemplateOutletContext]="{ item: item, level: level, isPage: isPage, isSection: isSection, isFirst: isFirst }">
            </ng-container>
            @for(sub of item.fields; track sub.name){
                <ng-container [ngTemplateOutlet]="hierarchicalFieldTemplate" [ngTemplateOutletContext]="{ item: sub, level: level + 1, isPage: false, isSection: isPage, isFirst: false }">
                </ng-container>
            }
        }
        @else{
            <!-- no nested fields -->
            <ng-container [ngTemplateOutlet]="fieldContentTemplate" [ngTemplateOutletContext]="{ item: item, level: level }">
            </ng-container>
        }
    </ng-template>

    <!-- Header template for pages and sections -->
    <ng-template #hierarchyHeaderTemplate let-item="item" let-level="level" let-isPage="isPage" let-isSection="isSection" let-isFirst="isFirst">
        @if (isPage && !isFirst) {
            <w-divider orientation="horizontal" mode="secondary" [ngStyle]="{'margin-left.px': level * 20}"></w-divider>
        }
        <div class="list-item hierarchy-header" [ngClass]="{'page-header': isPage, 'section-header': isSection}" [ngStyle]="{'padding-left.px': level * 20}">
            <div class="content">
                <div class="title">
                    <span class="prefix">{{ isPage ? 'Page:' : isSection ? 'Section:' : '' }}</span>
                    @if (item?.highlightName || item?.displayName) {
                        <span [innerHTML]="item?.highlightName ?? item?.displayName" (click)="copyTitle($safeNavigationMigration(item?.displayName)); $event.stopPropagation()" style="cursor: pointer"></span>
                        <a class="copy-title-link" (click)="copyTitle($safeNavigationMigration(item?.displayName)); $event.stopPropagation()">
                            <i class="fa-thin fa-copy"></i>
                        </a>
                    } @else {
                        <span class="untitled">(Untitled)</span>
                    }
                </div>
                @if(isSection && item.isRepeat){
                    <div class="description repeat-section-field">
                        <a class="copy-link">
                            <span (click)="copy(item); $event.stopPropagation()">{{item.name}}</span>
                            <span class="word-syntax" (click)="copy(item, true); $event.stopPropagation()">
                                <i class="fa-thin fa-file-word"></i>
                            </span>
                        </a>
                    </div>
                }
            </div>
        </div>
    </ng-template>

    <ng-template #arrayFieldTemplate let-item="item" let-level="level">
        <li>
            <ng-container [ngTemplateOutlet]="hierarchicalFieldTemplate" [ngTemplateOutletContext]="{ item: item, level: level, isPage: false, isSection: false }">
            </ng-container>
        </li>
        @if(!!item.arrayFields?.length){

            <ul class="array-fields">
                <ng-container *ngFor="let child of item.arrayFields" [ngTemplateOutlet]="arrayFieldTemplate" [ngTemplateOutletContext]="{ item: child, level: level +1 }">
                </ng-container>
            </ul>
        }
    </ng-template>

    <ng-template #fieldContentTemplate let-item="item" let-level="level">
        <div class="list-item list-item-field" [ngStyle]="{'padding-left.px':level * 20}">
            <div class="content">
                <div class="title">
                    <span [innerHTML]="item?.highlightName ?? item?.displayName" (click)="copyTitle($safeNavigationMigration(item?.displayName)); $event.stopPropagation()" style="cursor: pointer"></span>
                    @if(!!item.arrayFields?.length){
                        <span> ({{item.arrayFields?.length}}) </span>
                        }
                        <a class="copy-title-link" (click)="copyTitle($safeNavigationMigration(item?.displayName)); $event.stopPropagation()">
                            <i class="fa-thin fa-copy"></i>
                        </a>
                </div>
                <div class="description">
                    <a class="copy-link">
                        <span (click)="copy(item)">{{item.name}}</span>
                        <span class="word-syntax" (click)="copy(item, true)"><i class="fa-thin fa-file-word"></i></span>
                    </a>
                    @if(item.description){
                        <div> {{item.description}}</div>
                    }
                </div>
            </div>
        </div>
    </ng-template>